<template>
  <div class="row loyalty-store-report">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; flex-wrap: wrap;">
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="margin: 0;">
                <label>{{ $t('reports.dateInterval') }}</label>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  size="small"
                  style="width: 260px;"
                />
              </div>

              <div class="form-group" v-if="locations.length" style="margin: 0;">
                <label>{{ $t('orders.location') }}</label>
                <el-select
                  v-model="locationId"
                  clearable
                  filterable
                  size="small"
                  :placeholder="$t('general.select')"
                  style="width: 200px;"
                >
                  <el-option
                    v-for="loc in locations"
                    :key="loc.id"
                    :label="loc.name"
                    :value="loc.id"
                  />
                </el-select>
              </div>

              <div class="form-group" style="margin: 0; flex: 0 0 180px;">
                <label>{{ $t('loyaltyStore.user') }}</label>
                <el-input v-model="userId" size="small" clearable :placeholder="$t('customers.id')" />
              </div>

              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>
          </div>

          <div class="data-table" style="margin-top: 20px;">
            <el-table
              :data="tableData"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
              @row-click="onRowClick"
            >
              <el-table-column prop="reward_id" :label="$t('customers.id')" width="80" />
              <el-table-column :label="$t('loyaltyStore.reward')" min-width="160" show-overflow-tooltip>
                <template slot-scope="props">
                  {{ props.row.reward || props.row.reward_name || '—' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.rewardType')" width="110">
                <template slot-scope="props">
                  {{ props.row.reward_type === 'gift_card' ? $t('loyaltyStore.typeGiftCard') : $t('loyaltyStore.typeProduct') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.campaign')" min-width="140" show-overflow-tooltip>
                <template slot-scope="props">
                  {{ props.row.campaign || props.row.campaign_name || '—' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.pointsCost')" width="110">
                <template slot-scope="props">
                  {{ props.row.loyalty_points_cost }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.timesSold')" width="100">
                <template slot-scope="props">
                  {{ props.row.times_sold }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.totalPointsSpent')" width="140">
                <template slot-scope="props">
                  {{ props.row.total_loyalty_points_spent }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('loyaltyStore.totalGiftValue')" width="140">
                <template slot-scope="props">
                  <span v-if="props.row.reward_type === 'gift_card'">
                    {{ parseFloat(props.row.total_gift_card_value_issued || 0).toFixed(2) }} {{ currency }}
                  </span>
                  <span v-else>—</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Select, Option, DatePicker, Table, TableColumn } from 'element-ui'

Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)

export default {
  props: {
    isLoyaltyStoreReport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      dateRange: [],
      locationId: null,
      userId: '',
      locations: [],
      tableData: [],
      currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {})['currency_iso'])
    }
  },
  watch: {
    isLoyaltyStoreReport (active) {
      if (active) this.loadReport()
    }
  },
  mounted () {
    this.initLocations()
    if (this.isLoyaltyStoreReport) this.loadReport()
    this.$bus.$on('refresh-loyalty-store-report', this.loadReport)
  },
  beforeDestroy () {
    this.$bus.$off('refresh-loyalty-store-report', this.loadReport)
  },
  methods: {
    initLocations () {
      const company = this.$session.get('selectedCompanyData') || {}
      const locs = company.locations_details || []
      this.locations = locs.map((l) => ({
        id: l.true_id || l.id,
        name: l.name
      }))
    },
    applyFilters () {
      this.loadReport()
    },
    buildParams () {
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (this.dateRange && this.dateRange[0]) params.start_date = this.dateRange[0]
      if (this.dateRange && this.dateRange[1]) params.end_date = this.dateRange[1]
      if (this.locationId) params.location_id = this.locationId
      if (this.userId) params.user_id = this.userId
      return params
    },
    loadReport () {
      this.loading = true
      this.apiRequest('/reports/loyalty-store', 'GET', this.buildParams(), (response) => {
        this.loading = false
        if (response.status && response.data) {
          this.tableData = response.data.rewards || []
        } else {
          this.tableData = []
        }
      })
    },
    onRowClick (row) {
      if (!row || !row.reward_id) return
      const title = row.reward || row.reward_name || ('#' + row.reward_id)
      this.$router.push({
        path: '/reports/loyalty-store/rewards/' + row.reward_id + '/purchases',
        query: {
          title,
          type: row.reward_type || 'product',
          start_date: (this.dateRange && this.dateRange[0]) || '',
          end_date: (this.dateRange && this.dateRange[1]) || '',
          location_id: this.locationId || '',
          user_id: this.userId || ''
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/LoyaltyStoreReport.vue